import { memo } from 'react';
import { Badge } from '@bbpos/ui';
import { INVOICE_STATUS_BADGE } from './status';
import type { InvoiceStatus } from './types';

export const InvoiceStatusBadge = memo(function InvoiceStatusBadge({
  status,
}: {
  status: InvoiceStatus;
}) {
  const meta = INVOICE_STATUS_BADGE[status] ?? INVOICE_STATUS_BADGE.OUTSTANDING;
  return (
    <Badge variant={meta.variant} size="sm" dot>
      {meta.label}
    </Badge>
  );
});
